import React from 'react';
import { PageHeading, Heading, Text } from '../components/ui';
import { Link } from 'react-router-dom';

const FAQ = () => {
    return (
        <div className="min-h-screen bg-neutral-50 px-0">
            <div className="max-w-4xl mx-auto py-8 px-4">
                <PageHeading>Recipe Sharing, Attribution & Legal Questions</PageHeading>
                
                <div className="bg-neutral-0 hairline minimal-padding mt-8 space-y-8">
                    <div>
                        <Heading level={3} style={{ color: '#1b263b' }} className="mb-3">
                            Q1: Can I import recipes from other websites using Smart Transfer?
                        </Heading>
                        <Text size="sm" className="text-neutral-900">
                            Yes. Smart Transfer lets you save recipes from other websites into your private cookbook for your personal use. We'll try to pull in the title, ingredients, instructions, and source information.
                        </Text>
                    </div>

                    <div>
                        <Heading level={3} style={{ color: '#1b263b' }} className="mb-3">
                            Q2: Can I publish imported recipes to the 4RKED community?
                        </Heading>
                        <Text size="sm" className="text-neutral-900">
                            It depends. The underlying idea and ingredients of a recipe are not protected by copyright, but the exact wording of the instructions, photos, story, and presentation usually are.
                        </Text>
                        <Text size="sm" className="text-neutral-900 mt-2">
                            To protect creators, we may limit public sharing of imported recipes to ingredients + a link to the original recipe, or ask you to write your own version in your own words.
                        </Text>
                    </div>

                    <div>
                        <Heading level={3} style={{ color: '#1b263b' }} className="mb-3">
                            Q3: Why do I have to keep the source URL and author name?
                        </Heading>
                        <Text size="sm" className="text-neutral-900">
                            Because the original recipe content belongs to the original creator. Attribution helps make sure they get proper credit and traffic. Please don't remove or falsify source information when importing a recipe.
                        </Text>
                    </div>

                    <div>
                        <Heading level={3} style={{ color: '#1b263b' }} className="mb-3">
                            Q4: What's the difference between personal use and public sharing?
                        </Heading>
                        <Text size="sm" className="text-neutral-900">
                            <strong>Personal use:</strong> Saving a recipe in your private cookbook to cook at home, plan meals, or build shopping lists.
                        </Text>
                        <Text size="sm" className="text-neutral-900 mt-2">
                            <strong>Public sharing:</strong> Publishing a recipe so other people can see it. Publicly sharing an imported recipe that copies the original author's creative content may infringe their rights.
                        </Text>
                    </div>

                    <div>
                        <Heading level={3} style={{ color: '#1b263b' }} className="mb-3">
                            Q5: What should I do if I see my recipe or content here without permission?
                        </Heading>
                        <Text size="sm" className="text-neutral-900">
                            We take copyright seriously. If you believe your content has been posted on 4RKED without your permission, please review our{' '}
                            <Link to="/dmca-policy" className="underline">DMCA Policy</Link> for instructions on how to submit a takedown request.
                        </Text>
                    </div>

                    <div>
                        <Heading level={3} style={{ color: '#1b263b' }} className="mb-3">
                            Q6: How does 4RKED protect my personal information and allergies data?
                        </Heading>
                        <Text size="sm" className="text-neutral-900">
                            We use encryption in transit (HTTPS), secure password storage, and other safeguards to protect your data. Allergy and dietary information is used to personalize your experience (like filtering recipes) and is not shared with other users unless you include it in content you choose to publish. For full details, see our{' '}
                            <Link to="/privacy-policy" className="underline">Privacy Policy</Link>.
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;

